import { completeStep, getCurrentStage, getSteps, skipStep } from '../api';
import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';

import type { RootState } from './../store';
import { selectSession } from './sessionSlice';

const exampleStage = {
	stepCount: 6,
	stageAction: 'reservation/checkin/',
	stageCompletion: 1,
	reservationStageHistory: [
		{
			stageID: 1,
			isComplete: false,
			createdDate: '2023-06-22T10:14:51.983',
			updatedDate: '0001-01-01T00:00:00',
			reservationID: 1,
			stepID: 1,
			isSkipped: false,
			action: 'reservation/checkin/',
			controller: null,
			stepIcon: 'far fa-file',
			stepTitle: 'Verification',
			stepDesc: 'reserv',
			isEnabled: true,
			isMandatory: false,
		},
	],
};
const exampleStages = [
	{
		stepID: 1,
		status: 'completed',
		stepTitle: 'Verification',
		action: '/reservation/checkin/',
	},
	{
		stepID: 2,
		status: 'completed',
		stepTitle: 'Document Upload',
		action: '/scan/checkin/',
	},
	{
		stepID: 3,
		status: 'skipped',
		stepTitle: 'Upsell',
		action: '/upsell/checkin/',
	},
	{
		stepID: 4,
		status: 'skipped',
		stepTitle: 'Consent Form',
		action: '/consent/checkin/',
	},
	{
		stepID: 5,
		status: 'pending',
		stepTitle: 'Payment',
		action: '/payment/checkin/',
	},
	{
		stepID: 6,
		status: 'pending',
		stepTitle: 'Thank You',
		action: 'thankyou/checkin/',
	},
];

export const missing = [3];

/*
 * This is in relation to error value for complete and skip stage.
 * Null -> representing initial state and basically any timeslice not immediately after action
 * True -> successful execution of action
 * False -> failure case
 */

const initialState = {
	stages: null,
	stage: null,
	history: null,
	error: {
		completeStage: null,
		skipStage: null,
		fetchStage: null,
		fetchStages: null,
	},
} as any;

export const completeStage = createAsyncThunk<
	object,
	{
		token: string;
		stageID: number;
		ReservationID: string;
		type: string;
		confirmationNo: string;
		stages: object[];
		propertyCode: string; //added new
	}
>('Profile/CompleteStage', async (stageParam, thunkAPI) => {
	const {
		token,
		stageID,
		ReservationID,
		type,
		confirmationNo,
		stages,
		propertyCode,
	} = stageParam;
	await completeStep(token, stageID, ReservationID, confirmationNo);
	// await modifyReservationBooking(token);
	const response = await getCurrentStage(
		token,
		type,
		confirmationNo,
		propertyCode
	);

	// const stepID =
	// 	response?.data?.data?.reservationStageHistory[0]?.isComplete ||
	// 	response?.data?.data?.reservationStageHistory[0]?.isSkipped
	// 		? response?.data?.data?.stageCompletion + 1
	// 		: response?.data?.data?.stageCompletion;

	const completedStageIndex = stages.findIndex((stage: any) => {
		return stage.stepID === response?.data?.data?.stageCompletion;
	});

	if (completedStageIndex !== -1 && completedStageIndex < stages.length - 1) {
		const nextStage = stages[completedStageIndex + 1];
		console.log(nextStage);
		return nextStage;
	} else {
		const nextStage =
			stages[completedStageIndex === -1 ? 0 : completedStageIndex];
		return nextStage;
	}
	// const currentStage = stages.find((stage: any) => {
	// 	return stage.stepID === stepID;
	// });

	// if (currentStage !== null && currentStage !== undefined) {
	// 	return currentStage;
	// }

	// const nextStage = (
	// 	stages.find((stage: any) => (stage as any).stepID > stepID) as any
	// )?.stepID;

	// return nextStage;
});

export const skipStage = createAsyncThunk<
	object,
	{
		token: string;
		stageID: number;
		ReservationID: string;
		type: string;
		confirmationNo: string;
		stages: object[];
	}
>('Profile/SkipStage', async (stageParam, thunkAPI) => {
	const { token, stageID, ReservationID, type, confirmationNo, stages } =
		stageParam;
	await skipStep(token, stageID, ReservationID);
	const response = await getCurrentStage(token, type, confirmationNo);
	// const stepID =
	// 	response?.data?.data?.reservationStageHistory[0]?.isComplete ||
	// 	response?.data?.data?.reservationStageHistory[0]?.isSkipped
	// 		? response?.data?.data?.stageCompletion + 1
	// 		: response?.data?.data?.stageCompletion;
	// const currentStage = stages.find((stage: any) => {
	// 	return stage.stepID === stepID;
	// });
	// return currentStage;
	const completedStageIndex = stages.findIndex((stage: any) => {
		return stage.stepID === response?.data?.data?.stageCompletion;
	});

	if (completedStageIndex !== -1 && completedStageIndex < stages.length - 1) {
		if (
			response?.data?.data?.reservationStageHistory[0]?.isComplete ||
			response?.data?.data?.reservationStageHistory[0]?.isSkipped
		) {
			const nextStage = stages[completedStageIndex + 1];
			console.log(nextStage);
			return nextStage;
		} else {
			const nextStage = stages[completedStageIndex];
			return nextStage;
		}
	} else {
		const nextStage =
			stages[completedStageIndex === -1 ? 0 : completedStageIndex];
		return nextStage;
	}
});

export const fetchStage = createAsyncThunk<
	{ stage: object | undefined; history: any },
	{ token: string; type: string; confirmationNo: string; stages: object[] }
>('Profile/FetchStage', async (stageParam, thunkAPI) => {
	const { token, type, confirmationNo, stages } = stageParam;
	const response = await getCurrentStage(token, type, confirmationNo);

	// const stepID =
	// 	response?.data?.data?.reservationStageHistory[0]?.isComplete ||
	// 	response?.data?.data?.reservationStageHistory[0]?.isSkipped
	// 		? response?.data?.data?.stageCompletion + 1
	// 		: response?.data?.data?.stageCompletion;

	const stepID =
		response?.data?.data?.reservationStageHistory[0]?.isComplete ||
		response?.data?.data?.reservationStageHistory[0]?.isSkipped
			? response?.data?.data?.stageCompletion
			: response?.data?.data?.stageCompletion;

	const completedStageIndex = stages.findIndex((stage: any) => {
		return stage.stepID === stepID;
	});
	let nextStage = null;
	if (completedStageIndex !== -1 && completedStageIndex < stages.length - 1) {
		if (
			response?.data?.data?.reservationStageHistory[0]?.isComplete ||
			response?.data?.data?.reservationStageHistory[0]?.isSkipped
		) {
			nextStage = stages[completedStageIndex + 1];
			console.log(nextStage);
		} else {
			nextStage = stages[completedStageIndex];
		}
	} else {
		nextStage = stages[completedStageIndex === -1 ? 0 : completedStageIndex];
	}
	/* eslint-disable no-debugger */
	//debugger;
	/* eslint-enable no-debugger */
	console.log('currentStage--' + JSON.stringify(nextStage));

	return {
		stage: nextStage,
		history: response?.data?.data?.reservationStageHistory,
	};
});

export const fetchStages = createAsyncThunk<
	object,
	{ token: string; type: string }
>('Profile/FetchStages', async (stagesParam, thunkAPI) => {
	const { token, type } = stagesParam;
	const response = await getSteps(token, type);
	return response?.data?.data;
});

const stageSlice = createSlice({
	name: 'stage',
	initialState,
	reducers: {
		clearError: (state) => {
			state.error = null;
		},
	},
	extraReducers: (builder) => {
		builder.addCase(completeStage.fulfilled, (state, action) => {
			state.stage = action?.payload;
			state.error.completeStage = { status: true };
		});

		builder.addCase(completeStage.rejected, (state, action) => {
			state.error.completeStage = { status: true, result: action.error };
		});

		builder.addCase(skipStage.fulfilled, (state, action) => {
			state.stage = action?.payload;
			state.error.skipStage = { status: true };
		});

		builder.addCase(skipStage.rejected, (state, action) => {
			state.error.skipStage = { status: true, result: action.error };
		});

		builder.addCase(fetchStage.fulfilled, (state, action) => {
			state.stage = action?.payload?.stage;
			state.history = action?.payload?.history;
			state.error.fetchStage = null;
		});

		builder.addCase(fetchStage.rejected, (state, action) => {
			state.error.fetchStage = action?.error;
		});

		builder.addCase(fetchStages.fulfilled, (state, action) => {
			state.stages = action?.payload;
			state.error.fetchStages = null;
		});

		builder.addCase(fetchStages.rejected, (state, action) => {
			state.error.fetchStages = action?.error;
		});
	},
});

export const { clearError } = stageSlice.actions;
export const selectStage = (state: RootState) => state.stage;
export default stageSlice.reducer;
